// Склонение ФИО в родительный (gen) и дательный (dat) падеж — простые правила для документов.
// Результат подставляется в форму, где его можно поправить руками.
const HARD = /[гкхжшчщ]$/i;

function ending(w, rules) {
  for (const [re, gen, dat, cut] of rules) {
    if (re.test(w)) {
      const base = w.slice(0, w.length - cut);
      return { gen: base + gen, dat: base + dat };
    }
  }
  return { gen: w, dat: w };
}

function surname(w, female) {
  if (!w) return { gen: '', dat: '' };
  if (/(о|е|э|и|ы|у|ю|их|ых|аго|яго)$/i.test(w)) return { gen: w, dat: w };
  if (female) {
    if (/(ова|ева|ёва|ина|ына)$/i.test(w)) return { gen: w.slice(0, -1) + 'ой', dat: w.slice(0, -1) + 'ой' };
    if (/ая$/i.test(w)) return { gen: w.slice(0, -2) + 'ой', dat: w.slice(0, -2) + 'ой' };
    if (/яя$/i.test(w)) return { gen: w.slice(0, -2) + 'ей', dat: w.slice(0, -2) + 'ей' };
    if (/а$/i.test(w)) { const b = w.slice(0, -1); return { gen: b + (HARD.test(b) ? 'и' : 'ы'), dat: b + 'е' }; }
    if (/я$/i.test(w)) return { gen: w.slice(0, -1) + 'и', dat: w.slice(0, -1) + 'е' };
    return { gen: w, dat: w };
  }
  return ending(w, [
    [/(ский|цкий)$/i, 'ого', 'ому', 2],
    [/(ой|ый)$/i, 'ого', 'ому', 2],
    [/ий$/i, 'ия', 'ию', 2],
    [/й$/i, 'я', 'ю', 1],
    [/ь$/i, 'я', 'ю', 1],
    [/а$/i, HARD.test(w.slice(0, -1)) ? 'и' : 'ы', 'е', 1],
    [/я$/i, 'и', 'е', 1],
    [/[бвгджзклмнпрстфхцчшщ]$/i, 'а', 'у', 0],
  ]);
}

function firstName(w, female) {
  if (!w) return { gen: '', dat: '' };
  if (female) {
    if (/ия$/i.test(w)) return { gen: w.slice(0, -1) + 'и', dat: w.slice(0, -1) + 'и' };
    if (/а$/i.test(w)) { const b = w.slice(0, -1); return { gen: b + (HARD.test(b) ? 'и' : 'ы'), dat: b + 'е' }; }
    if (/я$/i.test(w)) return { gen: w.slice(0, -1) + 'и', dat: w.slice(0, -1) + 'е' };
    if (/ь$/i.test(w)) return { gen: w.slice(0, -1) + 'и', dat: w.slice(0, -1) + 'и' };
    return { gen: w, dat: w };
  }
  return ending(w, [
    [/ий$/i, 'ия', 'ию', 2],
    [/[йь]$/i, 'я', 'ю', 1],
    [/а$/i, HARD.test(w.slice(0, -1)) ? 'и' : 'ы', 'е', 1],
    [/я$/i, 'и', 'е', 1],
    [/[бвгджзклмнпрстфхцчшщ]$/i, 'а', 'у', 0],
  ]);
}

function patronymic(w, female) {
  if (!w) return { gen: '', dat: '' };
  if (female && /на$/i.test(w)) return { gen: w.slice(0, -1) + 'ы', dat: w.slice(0, -1) + 'е' };
  if (!female && /ч$/i.test(w)) return { gen: w + 'а', dat: w + 'у' };
  return { gen: w, dat: w };
}

export function declineFio(last, first, middle) {
  const female = /(вна|чна|кызы)$/i.test(middle || '');
  const s = surname(last, female), f = firstName(first, female), m = patronymic(middle, female);
  const join = k => [s[k], f[k], m[k]].filter(Boolean).join(' ');
  return { gen: join('gen'), dat: join('dat') };
}
